import { Component, OnInit } from '@angular/core';
import { Company } from 'src/app/model/company/company';
import { CompaniesService } from 'src/app/services/http/companies/companies.service';


@Component({
  selector: 'app-companies-list',
  templateUrl: './companies-list.component.html',
  styleUrls: ['./companies-list.component.scss']
})
export class CompaniesListComponent implements OnInit {

  constructor(private service: CompaniesService) { }

  public companies !: Company[];
  public sortDirection: boolean = false;

  ngOnInit(): void {
    
    
    /* SHOULD NOT TRY TO GET ONE COMPANY... SHOULD GET LIST HERE ! 
    let id = '42';
    console.error( ' loading hardcoded id ' + id)
    this.service.getCompany(id).subscribe((companies) => {
      // console.log(companies.societes[0].id_societe);
      console.log(companies)
      this.companies = companies;
    });*/


/** Liste First */

this.service.getCompanies().subscribe((companies) => {
   console.log(companies);
  this.companies = companies;
});
  }


  /**
   * Sort the table with string values (asc and dsc)
   * @param column 
   */
  sortby(column: string): void {
   /* console.log('Tri par la colonne ' + column);
    let dataType;

    for (let i = 0; i < this.companies.societes.length; i++) {
      dataType = typeof this.companies.societes[i][column];
      console.log(dataType)
    }

      this.sortDirection = !this.sortDirection;
      console.log(dataType);
      switch (dataType) {
  
        case 'string':
          this.sortStringColumn(this.sortDirection, column);
          break;
      }
      */
  }

  public sortStringColumn(sort: any, columnName: any): void {
   /* this.companies.societes = this.companies.societes.sort((a: any, b: any) => {
      if (a[columnName] !== undefined) {
        return sort ? a[columnName].localeCompare(b[columnName], undefined, { numeric: true }) : b[columnName].localeCompare(a[columnName], undefined, { numeric: true });
      } else {
        a[columnName] = "";
        return sort ? a[columnName].localeCompare(b[columnName], undefined, { numeric: true }) : b[columnName].localeCompare(a[columnName], undefined, { numeric: true });
      }
    });*/
  }

}
